import { formatBasicDetails } from "components/ArticleDetails/helper";
import ArticleTimeline from "themes/elements/ArticleTimeline";
import AvatarComp from "themes/elements/Avatar";
import TagComp from "themes/elements/Tag";
import utils from "utils/utils";
import style from "../../details.module.scss";

function ContentInfo(props) {
  const { selectedArticle } = props;
  /**
   * @param {Object} selectedArticle - The selected news item to format.
   * @returns {Object} The formatted basic details of article.
   * Status, Image caption, Author, Recipients, Source, Created date, Expiry date & time
   */
  const basicInformation = formatBasicDetails(selectedArticle);

  return (
    <>
      <div className={style["basic-info-wrapper"]}>
        {/* Basic information title */}
        <h4 className={style["card-title"]}>Basic information:</h4>
        {basicInformation.map(
          (detail, index) =>
            detail.value &&
            !utils.isEmpty(detail.value) && (
              <div key={index} className={style["detail-container"]}>
                {/* contentInfo titles : Status, Image caption:,
                   Author, Recipients, Source, Created date, Expiry date & time*/}
                <h5 className={style["detail-key"]}>{detail.key}:</h5>
                {Array.isArray(detail.value) ? (
                  <div className={style["detail-key-list"]}>
                    {detail.value.map((item, i) => (
                      /* Status, Recipients */
                      <TagComp key={i}>{item}</TagComp>
                    ))}
                  </div>
                ) : (
                  <div className="flex align-center gap-1">
                    {detail.avatar &&
                      (selectedArticle?.created_user_image ? (
                        /* Author image */
                        <span className={style["avatar-img"]}>
                          <img
                            src={selectedArticle?.created_user_image}
                            alt="avatar"
                          />
                        </span>
                      ) : (
                        /*Author avatar : first letter of author name*/
                        <AvatarComp blue>
                          {selectedArticle?.created_user_name
                            ?.slice(0, 1)
                            .toUpperCase()}
                        </AvatarComp>
                      ))}
                    {detail.counsilor &&
                      (selectedArticle?.councilor_image ? (
                        /* Author image */
                        <AvatarComp
                          shape="square"
                          size={24}
                          blue
                          src={selectedArticle?.councilor_image}
                        />
                      ) : (
                        /*Author avatar : first letter of author name*/
                        <AvatarComp blue>
                          {selectedArticle?.first_name
                            ?.slice(0, 1)
                            .toUpperCase()}
                        </AvatarComp>
                      ))}
                    {/* Author name */}
                    <h6 className={style["detail-value"]}>{detail.value}</h6>
                  </div>
                )}
              </div>
            )
        )}
      </div>
      {/* Activity Log time line */}
      <div className={style["basic-info-wrapper"]}>
        <h4 className={style["card-title"]}>Activity log:</h4>
        <ArticleTimeline timelineData={selectedArticle?.activities} />
      </div>
    </>
  );
}

export default ContentInfo;
